module.exports = __webpack_public_path__ + "static/media/Restaurant.9ad29769.png";